/**
 * Shared Utility connection-spec formatting used by the equipment
 * Utilities panel and the Utility entity Consumers panel.
 */

export function formatUtilitySpec(props: Record<string, unknown>): string | null {
  const bits: string[] = []
  if (typeof props['voltage_v'] === 'number') bits.push(`${props['voltage_v']} V`)
  if (typeof props['phase'] === 'number' || typeof props['phase'] === 'string') {
    bits.push(`${props['phase']}φ`)
  }
  if (typeof props['fla_amps'] === 'number') bits.push(`FLA ${props['fla_amps']} A`)
  if (typeof props['hp'] === 'number') bits.push(`${props['hp']} hp`)
  if (typeof props['kw'] === 'number') bits.push(`${props['kw']} kW`)
  if (typeof props['mcc_bucket_id'] === 'string' && props['mcc_bucket_id']) {
    bits.push(`MCC ${props['mcc_bucket_id']}`)
  }
  return bits.length > 0 ? bits.join(' · ') : null
}

export function basisStatusClass(status: string): string {
  switch (status) {
    case 'nameplate':
    case 'field_measured':
      return 'border-emerald-400/40 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300'
    case 'vendor_spec':
      return 'border-sky-400/40 bg-sky-500/10 text-sky-700 dark:text-sky-300'
    case 'estimated':
      return 'border-amber-400/40 bg-amber-500/10 text-amber-700 dark:text-amber-300'
    default:
      return ''
  }
}
